import styled from "styled-components";

export const RecommendWrapper = styled.div``;
export const Content = styled.div`
	background-color: #fff;
	display: flex;
`;

export const RecommendLeft = styled.div`
	padding: 20px;
	width: 729px;
`;

export const RecommendRight = styled.div`
	width: 250px;
	border: 1px solid #d3d3d3;
	border-width: 0 1px;
`;
